"use client";
import { useEffect, useState } from "react";
import { request } from "../api/request.tsx";

interface GetListProps {
  url: string;
  params?: any;
  dependencies?: any;
  isLazy?: boolean;
  dependencies2?: any;
  dependencies1?: any;
  dependencies3?: any;
}
export function GetList<T>({
  url,
  params,
  dependencies,
  isLazy,
  dependencies2,
  dependencies1,
  dependencies3,
}: GetListProps): {
  data: T | null;
  loading: boolean;
  error: Error | null;
  search: (queryString: string) => void;
  loadMore: (page: number) => void;
  reLoad: () => void;
  totalPage: number;
} {
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalPage, setTotalPage] = useState(0);
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  useEffect(() => {
    if (!isLazy) {
      getData();
    }
  }, [dependencies, dependencies2, dependencies1, dependencies3]);

  const search = (query: string) => {
    setSearchQuery(query);
    setPage(1);
    getData(1, query);
  };

  const loadMore = (apage: number) => {
    setPage(apage);
    getData(apage, searchQuery);
  };

  const reLoad = () => {
    setPage(1);
    getData(1, searchQuery);
  };

  const getData = async (_page = page, search = "") => {
    if (isLazy) {
      setLoading(true);
      const respone = await request(url, null, "GET", {
        page: _page,
        limit: 20,
        search,
        ...params,
      });
      setData(respone?.data);
      setTotalPage(respone?.data?.totalPages);
    } else {
      setLoading(true);
      const respone = await request(url, null, "GET", params);
      setData(respone?.data);
    }
    setLoading(false);
  };

  return {
    data,
    loading,
    error,
    search,
    reLoad,
    loadMore,
    totalPage,
  };
}
